import { css } from 'lit';

export default css`
  :host {
    color: var(--sl-color-foreground-plain);
    padding-inline: var(--sl-size-100);
  }
`;
